import styled from "styled-components";
import { Field } from "redux-form/immutable";
import { injectIntl, type WrappedComponentProps } from "react-intl";

import { creatable } from "../../up-styled-creatable";
import { renderField } from "../../up-input";
import { selectBox } from "../../select-box";
import FormValueSelector from "../../up-form-value-selector";
import messages from "../messages";
import type { ResettableConditionFilterProps } from "../utils";

const Filter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media only screen and (max-width: 470px) {
    flex-direction: column;
    align-items: stretch;
    width: auto;
  }
`;

interface RowProps {
  margin?: string;
}

const Row = styled.div<RowProps>`
  display: flex;
  width: 100%;
  margin: ${(props) => (props.margin ? props.margin : "0 0 0 0")};
  @media only screen and (max-width: 680px) {
    margin-top: 0px;
  }
  @media only screen and (max-width: 440px) {
    flex-direction: column;
  }
`;

type UptainQueryProps = ResettableConditionFilterProps & WrappedComponentProps;

const UptainQuery = (props: UptainQueryProps) => (
  <Filter>
    <Row>
      <Field
        name={`${props.member}.filter.parameter`}
        component={renderField}
        placeholder="Query parameter"
      />
      <Field
        name={`${props.member}.filter.operator`}
        component={selectBox}
        customProps={{
          options: [
            { value: "empty", label: props.intl.formatMessage(messages.empty) },
            {
              value: "not-empty",
              label: props.intl.formatMessage(messages.notEmpty),
            },
            {
              value: "contains",
              label: props.intl.formatMessage(messages.contains),
            },
            {
              value: "contains-not",
              label: props.intl.formatMessage(messages.containsNot),
            },
          ],
          minWidth: '130px',
          margin: '0 0 0 10px',
          onChange: () => props.resetOnChange()
        }}
      />
    </Row>

    <FormValueSelector
      fieldName={`conditions[${props.member
        .split("[")[1]
        .charAt(0)}]filter.operator`}
    >
      {(operator) => {
        if (operator === "contains" || operator === "contains-not") {
          return (
            <Row margin="10px 0 0 0">
              <Field
                name={`${props.member}.filter.attribute`}
                component={creatable}
              />
            </Row>
          );
        }

        return undefined;
      }}
    </FormValueSelector>
  </Filter>
);

export default injectIntl(UptainQuery);
